import './job-queue.scss';

import { Box } from '@mui/material';
import { useStore } from 'mobx/StoreContext';
import { observer } from 'mobx-react-lite';
import React from 'react';

import BenchQueueTable from './components/BenchQueueTable';
import JobQueueHeader from './components/JobQueueHeader';
import JobQueueTable from './components/JobQueueTable';

const JobQueue: React.FC = () => {
  const { managementJobQueueService } = useStore();
  const { mainTab } = managementJobQueueService;
  return (
    <Box className="job-queue-view inter-font-family">
      <JobQueueHeader mainTab={mainTab} />

      <Box className="job-queue-content">
        <Box className="table-section">
          {mainTab === 1 ? <JobQueueTable /> : <BenchQueueTable />}
        </Box>
      </Box>
    </Box>
  );
};

export default observer(JobQueue);
